export const BASE_URL = process.env.REACT_APP_BASE_URL

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

export const IMG_LINK = process.env.REACT_APP_IMG_LINK

export const GOOGLE_MAP_API = process.env.REACT_APP_GOOGLE_MAP_API
